'use client';
import { SessionProvider } from 'next-auth/react';
import ToastProvider from '@/components/ui/ToastProvider';
import { InquiryProvider } from '@/contexts/InquiryContext';
import ProductProvider from '@/contexts/ProductContext';
import { SidebarProvider } from '@/contexts/SidebarContext';

export default function Providers({ children, productData }) {
    return (
        <SessionProvider>
            <ProductProvider productData={productData}>
                <SidebarProvider>
                    <ToastProvider>
                        <InquiryProvider>{children}</InquiryProvider>
                    </ToastProvider>
                </SidebarProvider>
            </ProductProvider>
        </SessionProvider>
    );
}
